'use client'

import { useEffect, useState } from "react"



export default function ProductHighlights({ highlights, translations }: { highlights: Record<string, string>, translations: any }) {
  const [keys, setKeys] = useState<string[]>([])
  useEffect(() => {
    if (highlights) {
      setKeys(Object?.keys(highlights))
    }

  }, [highlights])

  return (
    <>
      {
        keys.length > 0 && (
          <div className="bg-white rounded-[14px] w-full">
            <div className="font-bold text-sm mb-2">{translations["highlights"] || "Highlights"}</div>
            <div className="rounded-lg overflow-hidden border">
              <table className="w-full text-sm">
                <tbody>
                  {keys?.map((key) => (
                    highlights[key] && (
                      <tr key={key} className="even:bg-[#F7F7FA]">
                        <td className="font-semibold py-2 px-3 w-2/5 border-r rtl:border-l text-gray-500">{key}</td>
                        <td className=" py-2 px-3">{highlights[key]}</td>
                      </tr>
                    )
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      }
    </>
  )
}